/**
 * Adds padding to the last item as the gradient is wider.
 *
 * @param {Array} menuItems Array of items.
 */
export const addPaddingToMenuItem = ( menuItems ) => {
	menuItems = Array.from(menuItems);
	const lastItem = menuItems.slice( -1 )[ 0 ];
	const totalWidth = getTotalWidth( menuItems );
	const mediaSmall = window.matchMedia( '(min-width: 1180px)' );

	// If nav overflows the window.
	if ( totalWidth > window.innerWidth && mediaSmall.matches ) {
		lastItem.style.paddingRight = '130px';

		// Firefox displays it differently.
		// Padding is being ignored for overflow.
		if ( navigator.userAgent.includes( 'Firefox' ) ) {
			lastItem.setAttribute( 'data-last-item', 'true' );
		}
	}
};

/**
 * Gets total width of all menu items including margin and padding.
 *
 * @param {Array} menuItems Array of items.
 * @returns {number} Total width of the menu.
 */
export const getTotalWidth = (menuItems) => {
    if (!menuItems.length) {
        return 0;
    }

    let totalWidth = 0;
    menuItems.forEach((item) => {
        const style = window.getComputedStyle(item);
        const width = item.offsetWidth;
        const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        totalWidth += width + margin;

        let halfWidth = (width / 2).toString();
        item.setAttribute('data-middle-point', halfWidth);
    });

    return totalWidth;
};
